import React from 'react';
import PropTypes from 'prop-types';
import { GoogleAnalyticsProvider } from '../../components/googleAnalytics';
import { ContextPathProvider } from '../../components/contextpath';
import { AppStoreProvider } from '../../components/store';
import AppStore from './AppStore';
import VaccinationToolForm from './VaccinationToolForm';
import VaccinationToolHandler from './VaccinationToolHandler';
import EventEmitterProvider from '../../components/EventEmitterProvider';

const VaccinationTool = (props) => {
    const countryHandler = new VaccinationToolHandler({
        contextPath: props.contextPath,
    });

    return (
        <EventEmitterProvider>
            <GoogleAnalyticsProvider servicetoolName="VaccinationTool">
                <ContextPathProvider contextPath={props.contextPath}>
                    <AppStoreProvider store={new AppStore(countryHandler)}>
                        <VaccinationToolForm />
                    </AppStoreProvider>
                </ContextPathProvider>
            </GoogleAnalyticsProvider>
        </EventEmitterProvider>
    );
};

VaccinationTool.propTypes = {
    contextPath: PropTypes.string,
};

VaccinationTool.defaultProps = {
    contextPath: '',
};

export default VaccinationTool;



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationTool.jsx